import { AssetResolverBase } from '@lmnop/web-core';

export class WebsiteAssetResolver extends AssetResolverBase {
    public resolve(file: string): string {
        return `/${file}`;
    }
}
